import style from "./alert.module.css"

const AlertSession = () => {
    return (
        <>
        <div className={style.contenedor}>
            <div className={style.principal}>
            <h2 >Su sesión ha vencido</h2>
            <h3 >Por favor, vuelva a iniciar sesión</h3>
            </div>
        </div>
        </>
    )

}

export default AlertSession